module.exports = __webpack_public_path__ + "static/media/T2.35ea4267.svg";